export default "__VITE_ASSET__CK3V7uLi__"